import { quoteActions } from '../constants/registry/quotes-table.constant';
import { DynamicTableConfig } from '../interfaces/dynamic-table.interface';

export const pncQuotesTablePreset: Partial<DynamicTableConfig> = {
  columns: [
    { id: 'title' },
    { id: 'assignedBroker' },
    { id: 'status' },
    { id: 'lastActivity' },
    {
      id: 'contextMenu',
      props: {
        actions: [
          quoteActions['viewStatus'],
          quoteActions['assignToBroker'],
          quoteActions['viewProposal'],
          quoteActions['editEnquiry'],
        ],
      },
    },
  ],
};
